
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {swalConfirm, swalError} from '@/plugins/swal';

@Component
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  locationItems = [];
  jobsItems = [];
  messageCheckUser = null;
  category = '';
  location = null;
  jobtype = null;
  items = [
    {
      src:
        'https://www.dictio.id/uploads/db3342/original/3X/6/b/6b3194ebea481506686ea44c0c76d00b89542529.jpeg',
    },
  ];
  currentPage = 1;
  maxPerPage = 3;
  showReadMore = true;
  orders = 10;
  get idJob() {
    return this.$route.params.id;
  }
  async mounted() {
    await this.fetchDetail();
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch(
        'jobs/detailStatusApply',
        this.idJob,
      );
      this.finishLoading('detail');
      this.jobsItems = data;
    } catch (e) {
      this.catchError(e);
    }
  }
  async onSubmit() {
    const {value: confirmed} = await swalConfirm.fire({
      text: 'Apakah anda yakin ingin daftar pekerjaan ini?',
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
    });
    if (confirmed) {
      this.applyJobs();
    }
  }
  async applyJobs() {
    try {
      this.startLoading('saving');
      const form = {
        jobvacancy_id: this.$route.params.id,
      };
      const res = await this.$store.dispatch('jobs/applyJobs', form);
      if (res.status === 200) {
        this.finishLoading('saving');
        this.handleSuccess(res.data.message);
        this.$router.push('/aplication');
      }
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
